<template>
  <div class="contact-list">
  
    <vue-data-loading :loading="isLoading" :listens="['pull-down']" @pull-down="refresh">
      <div slot="pull-down-before">Pull to refresh</div>
      <div slot="pull-down-ready">Pull to refresh</div>
      <div slot="pull-down-loading">Loading ...</div>
      <div slot="completed">Up to date :)</div>

      <div class="contact-list-item" v-for="item in contacts" :key="item.id" @click="select(item)">
        <div class="avatar-container">
          <a-avatar v-if="item.thumbnailUrl" :src="item.thumbnailUrl" />
          <a-avatar v-if="!item.thumbnailUrl" icon="user" />
        </div>

        <div class="text-container">
          <div class="name">
            {{item.firstname}} {{item.lastname}}
          </div>
          <div class="cohort">
            {{item.cohort || '&nbsp;'}}
          </div>
        </div>
      </div>
    </vue-data-loading>

    <div class="showMoreContainer" v-observe-visibility="visibilityChanged" >
      <a-button type="dashed" v-show="showLoadMoreButton" @click="showMore">Load More</a-button>
    </div>

    <div v-if="!contacts || contacts.length == 0">
      <div v-for="index in 20" :key="index">
        <a-skeleton class="contact-list-item skeleton" active avatar title/>
      </div>
    </div>
    
  </div>
</template>
<script>
import VueDataLoading from 'vue-data-loading'

export default {
  components: {
    VueDataLoading
  },
  data () {
    return {
      sliceIndex: 50,
      loading: false
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters.getIsLoading
    },
    allContacts () {
      return this.$store.getters.contacts
    },
    contacts () {
      return this.allContacts.slice(0, this.sliceIndex)
    },
    showLoadMoreButton () {
      return this.sliceIndex < this.allContacts.length
    }
  },
  methods: {
    select (contact) {
      this.$router.push(`/contacts/${contact.id}`)
    },
    async refresh () {
      try {
        await this.$store.dispatch('updateContactList')
      } catch (error) {
      }
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        this.showMore()
      }
    },
    showMore () {
      this.sliceIndex += 100
    }
  }

}
</script>

<style scoped>
.contact-list-item {
  padding: 10px;
}

.contact-list-item:hover {
  background-color: rgba(0,0,0,0.03);
  cursor: pointer;
}

.contact-list-item {
  border-bottom: 1px solid #e8e8e8;
}

.contact-list-item.skeleton {
  padding: 10px;
  height: 30px;
  max-height: 30px;
  overflow: hidden;
}

.avatar-container {
  display: inline-block;
  overflow: hidden;
}

.text-container {
  padding-left: 5px;
  display: inline-block;
}

.text-container .name {
  font-weight: bold;
}

.text-container .cohort {
  font-size: 12px;
}

.showMoreContainer {
  margin-bottom: 10px;
  justify-content: center;
  display: flex;
}

.showMoreContainer .ant-btn {
  margin: 20px 0 20px 0;
}

</style>

<style lang="less">
.contact-list-item.skeleton.ant-skeleton.ant-skeleton-with-avatar {

  .ant-skeleton-avatar.ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
    width: 32px;
    height: 32px;
  }

  .ant-skeleton-paragraph {
    padding-left: 10px;
    margin-bottom: 0;
  }

  .ant-skeleton-paragraph > li {
    height: 12px;
  }

  .ant-skeleton-paragraph > li + li {
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactList.vue